import type { ReactNode } from 'react';

interface HandoutSectionTitleProps {
    children: ReactNode;
    className?: string;
}

/** Heading of a handout section (company values, key competencies, notes): one scale for the whole document. */
export const HandoutSectionTitle = ({ children, className = '' }: HandoutSectionTitleProps) => (
    <h3 className={`text-md text-navy font-bold tracking-wide uppercase ${className}`}>
        {children}
    </h3>
);
